module.exports = __webpack_public_path__ + "fonts/MyriadPro-SemiboldIt.ddc8214.woff";